import './TranslationSettings.scoped.scss'

function stripHtml(value: string): string {
  return value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
}

function buildPreviewSrcDoc(html: string, placeholder: boolean): string {
  const previewClass = placeholder ? 'preview placeholder' : 'preview'
  const fontFamily = window.ENV?.CLIENT_BRAND['body_font'] || 'inherit'

  return `<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <link href="https://fonts.googleapis.com/css2?family=${fontFamily}:wght@400;700&display=swap" rel="stylesheet">
    <style>
      html, body {
        margin: 0;
        padding: 0;
        height: 100%;
      }

      body {
        overflow: hidden;
        font-family: ${fontFamily}, sans-serif;
        font-size: 16px;
        line-height: 1.2;
        color: #222;
      }

      .preview {
        box-sizing: border-box;
        padding: 0;
        height: 100%;
        overflow: hidden;
        word-break: break-word;
      }

      a {
        color: inherit;
        text-decoration: inherit;
        pointer-events: none;
      }
    </style>
  </head>
  <body>
    <div class="${previewClass}">${html}</div>
  </body>
</html>`
}

export default function TranslatableHtmlField({
  value,
  placeholder,
  onClick,
}: {
  value: string
  placeholder?: string
  onClick: () => void
}) {
  const showPlaceholder = !stripHtml(value || '')
  const previewHtml = showPlaceholder ? (placeholder || '') : value
  const previewSrcDoc = buildPreviewSrcDoc(previewHtml, showPlaceholder)

  return (
    <div
      className={`translatable-html-preview ${showPlaceholder ? 'placeholder' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClick() }}
    >
      <iframe
        className="translatable-html-preview-frame"
        title={showPlaceholder ? 'Placeholder preview' : 'HTML preview'}
        sandbox=""
        srcDoc={previewSrcDoc}
        tabIndex={-1}
        aria-hidden="true"
      />
      <span className="translatable-html-preview-edit">
        <SvgIconsEdit />
      </span>
    </div>
  )
}
